import {
  Button,
  Tooltip,
  TooltipFocusableTrigger,
} from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";

export const EXIT_TOUR = "Exit tour";

type CloseButtonProps = {
  onPress: () => void;
};

export function CloseButton({ onPress }: CloseButtonProps) {
  return (
    <Tooltip placement="top" content={EXIT_TOUR}>
      <TooltipFocusableTrigger>
        <Button
          variant="ghost"
          size="small"
          onPress={onPress}
          iconPosition="start"
        >
          <Icon name="formX" color="TextDefault" />
        </Button>
      </TooltipFocusableTrigger>
    </Tooltip>
  );
}
